import { render } from "./SchedulerDocumentAccordionTree.vue?vue&type=template&id=19c28a85&scoped=true&ts=true"
import script from "./SchedulerDocumentAccordionTree.vue?vue&type=script&lang=ts"
export * from "./SchedulerDocumentAccordionTree.vue?vue&type=script&lang=ts"

import "./SchedulerDocumentAccordionTree.vue?vue&type=style&index=0&id=19c28a85&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c28a85"]])

export default __exports__